<template>
  <div>
    <div id="carousel-wrapper">
      <swiper
        id="carousel"
        :options="swiperOptions"
      >
        <swiper-slide v-for="image in images" :key="image.id" class="slide">

          <a :href="image.url">
            <div class="carousel-image" v-bind:style="{ backgroundImage: `url('${image.imageUrl}')`}" />
            <div class="banner">
              <span class="text1">{{ image.title}}</span>
              <span class="text2">
                {{ $t('home.recruiting') }}
              </span>
            </div>
          </a>
        </swiper-slide>
        <div id="swiper-button-prev" class="swiper-button-prev" slot="button-prev"></div>
        <div id="swiper-button-next" class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <div id="symbols-wrapper">
      <router-link to="/activities/training" class="symbol" id="training">
        <div class="image" />
        <div class="text font-semibold">{{ $t('home.training')}}</div>
      </router-link>
      <router-link to="/activities/school" class="symbol" id="school">
        <div class="image" />
        <div class="text font-semibold">{{ $t('home.school')}}</div>
      </router-link>
      <router-link to="/activities/monday" class="symbol" id="monday">
        <div class="image" />
        <div class="text font-semibold">{{ $t('home.happyMonday')}}</div>
      </router-link>
      <router-link to="/activities/drama" class="symbol" id="drama">
        <div class="image" />
        <div class="text font-semibold">{{ $t('home.drama')}}</div>
      </router-link>
      <router-link to="/activities/phone" class="symbol" id="phone">
        <div class="image" />
        <div class="text font-semibold">{{ $t('home.phone')}}</div>
      </router-link>
      <router-link to="/activities/train" class="symbol" id="train">
        <div class="image" />
        <div class="text font-semibold">{{ $t('home.train')}}</div>
      </router-link>
    </div>

    <div id="home-desc">
      <p v-html="$t('home.desc')" />
    </div>
  </div>
</template>

<script>
  import { getFeaturedActivities } from '../models/Activity';

  export default {
    name: 'Home',
    mounted() {
      getFeaturedActivities().then((records) => {
        this.images = records.map(activity => ({
          id: activity._id,
          title: activity.title,
          imageUrl: activity.coverImage ? activity.coverImage.url : null,
          url: `/activities/${activity.category}/${activity._id}`,
        }));
      });
    },
    methods: {
    },
    data() {
      return {
        images: [],
        swiperOptions: {
          autoplay: 7000,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
          loop: true,
          initialSlide: 1,
        },
      };
    },
  };
</script>

<style lang="sass" scoped>
  @import "../styles/variables.sass"

  .carousel-image
    padding-top: 53%
    width: 100%
    background-size: cover

  .slide
    position: relative
    
  .banner
    display: flex
    justify-content: space-between
    flex-wrap: wrap

    @media #{$desktop}
      padding: 7px 14px
      height: 81px
      background-color: rgba(173, 170, 170, 0.7)
      position: absolute
      bottom: 25px
      left: 0
      right: 0
      border: 1px solid $dusty-gray

    @media #{$mobile}
      background-color: rgba(246, 138, 71, 0.7)
      padding: 10px 25px
      align-items: baseline
      margin-top: 4px

    span
      color: $white

    .text1
      @media #{$desktop}
        line-height: 63px
        font-size: 24px

      @media #{$mobile}
        font-size: 20px

    .text2
      white-space: nowrap
      margin-left: auto
      @media #{$desktop}
        font-size: 18px
        margin-top: 42px

      @media #{$mobile}
        font-size: 14px
        margin-top: 4px

  #carousel-wrapper
    position: relative
    max-width: 775px
    margin: 0 auto
    margin-top: 20px

  #symbols-wrapper
    display: flex
    max-width: 775px
    align-items: baseline
    justify-content: space-between
    margin: 20px auto 0

    @media #{$desktop-small}
      width: 450px
      flex-wrap: wrap

    @media #{$mobile}
      width: 300px
      flex-wrap: wrap

    .symbol
      cursor: pointer
      width: 130px
      margin-bottom: 20px

      .text
        font-size: 16px
        white-space: nowrap
        text-align: center

      .image
        text-align: center
        margin: 0 auto
        width: 100px
        height: 66px
        background-repeat: no-repeat
        background-position: center

      &#training
        .image
          background-image: url('../../static/training-icon.png')
          background-size: 80px 55px
        .text
          color: $leather
        @media #{$desktop}
          margin-right: 9px

      &#school
        .image
          background-image: url('../../static/school-icon.png')
          background-size: 100px 47px
        .text
          color: $jaffa

      &#monday
        .image
          background-image: url('../../static/monday-icon.png')
          background-size: 65px 62px
        .text
          color: $fountain-blue
        @media #{$desktop}
          margin-left: 22px

      &#drama
        .image
          background-image: url('../../static/drama-icon.png')
          background-size: 80px 66px
        .text
          color: $yellow-orange

      &#phone
        .image
          background-image: url('../../static/line-icon.png')
          background-size: 69px 56px
        .text
          color: $froly-2

      &#train
        .image
          background-image: url('../../static/train-icon.png')
          background-size: 80px 54px
        .text
          color: $leather

  #home-desc
    background-image: url('../../static/background-sky.png')
    background-position: center
    background-size: 833px 412px

    p
      color: $white
      margin: 0 auto
      padding-top: 130px
      padding-bottom: 130px
      font-size: 14px

      @media #{$mobile}
        padding-right: 37px
        padding-left: 37px

      @media #{$desktop}
        width: 450px

</style>

<style lang="sass">
  @import "../styles/variables.sass"
  #home-desc p span
    font-size: 24px
    &#t1
      color: $mandys-pink
    &#t2
      color: $feta
    &#t3
      color: $carousel-pink
    &#t4
      color: $periwinkle

  #swiper-button-next, #swiper-button-prev
    background-image: url('../../static/carousel-right-arrow.png')
    background-size: 33px 34px
    width: 70px
    height: 90px

    @media #{$desktop}
      right: 0px
      top: calc(50% - 15px)

    @media #{$mobile}
      background-size: 25px 25px
        width: 25px
        height: 25px
      width: 40px
      height: 70px
      top: calc(50% - 50px)

  #swiper-button-prev
    @media #{$desktop}
      left: 0px
    -moz-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    filter: FlipH;
    -ms-filter: "FlipH";

</style>



// WEBPACK FOOTER //
// src/components/Home.vue